import { useEffect } from 'react';
import { useLocation, Routes, Route, Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import indexOf from 'lodash/indexOf';
import cx from 'classnames';
import SideNav from '@components/SideNav';
import NotFound from '@components/NotFound';
import AppActions from '~/actions/app';
import privateRoutes from '~/routes/private';
import publicRoutes from '~/routes/public';
import { UserRoles } from '../../services/config';

const Landings = ['/hcm', '/library', '/analytics', '/vendor-ratings', '/events'];

const Content = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const role = useSelector((state) => state.app.app_role_id);
    const auth = useSelector((state) => state.app.token);
    const isLanding = indexOf(Landings, location.pathname) > -1;

    useEffect(() => {
        if (role === 1) dispatch(AppActions.getcompaniesRequest());
        if (auth) dispatch(AppActions.getlibraryfiltersRequest());
    }, [role, auth, dispatch]);

    const routes = auth ? privateRoutes : publicRoutes;

    return (
        <div id="ds-content" className={cx('content', !isLanding && 'logged')}>
            <div className="main">
                <Routes>
                    {routes.map((item, key) =>
                        item.from ? (
                            <Route key={key} path={item.from} element={<Navigate to={item.to} replace />} />
                        ) : item.component ? (
                            <Route key={key} path={item.path} element={<item.component />} />
                        ) : (
                            <Route key={key} path={item.path} element={<div>Component not found</div>} />
                        )
                    )}
                    <Route path="/" element={<Navigate to="/hcm" replace />} />
                    <Route path="/login" element={<Navigate to="/hcm?login=true" replace />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </div>
           {!isLanding &&<SideNav />}
        </div>
    );
};

export default Content;
